import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import { startLoading,stopLoading, startFormLoading, stopFormLoading} from './loader';

import { setEasyWalkThroughFormData } from './easyWalkThroughForm';
import { toast } from 'react-toastify';
import { fetchSuiteCounts } from './suites';
import { setValidation, clearValidation } from './validation';
import { fetchWalkThroughsDone } from './walkThroughs';

export const setPropertyWalkThroughFormData = payload => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_DATA,
  payload,
});

export const setPropertyWalkThroughFormNextStep = () => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP,
});

export const setPropertyWalkThroughFormPreviousStep = () => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP,
});

export const setPropertyWalkThroughFormStep = step => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FROM_STEP,
  payload: {
    step,
  },
});

export const exitPropertyWalkThroughForm = () => ({
  type: TYPES.EXIT_PROPERTY_WALK_THROUGH_FORM,
});

export const setPropertyWalkThroughFormIsVisible = payload => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE,
  payload
});


export const saveWalkthroughChecklist = payload => ({
  type: TYPES.SET_OFFLINE_WALKTHROUGH_SAVE_ACTIONS,
  payload
});

export const changeWalkthroughStatus = (payload) => ({
  type: TYPES.FETCH_WALK_THROUGHS_DONE,
  payload,
})

export const saveConfigType = data => dispatch =>{
  return client.saveConfigType(data).then( response => {    
    if(response.status === 200 || response.ok){
      response.json().then( responsejson => {        
        dispatch(setPropertyWalkThroughFormData({configTypeSaved:responsejson.data[0],
          walkthroughId:responsejson.data[0].id}))
      })
    }else{
      // alert('some thing went wrong in saving cofig type')
    }
  })
}

export const updateConfigType =data => dispatch =>{
  dispatch(setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: true }))
  return client.updateConfigType(data).then( response => {
    if(response.status === 200 || response.ok){
      dispatch(setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: false }))
      response.json().then(responsejson => {
        if(responsejson && responsejson.statusCode === 200) {
          dispatch(setPropertyWalkThroughFormData({ checkList: [] }))
          dispatch(setPropertyWalkThroughFormStep(1))
        } else {
           alert('some thing went wrong in updating cofig walkthrough.')
        }         
        }
      )
    }
  }).catch(() => {
    dispatch(setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: false }))
  })
}

export const saveCopyFromExisting = (data) => dispatch =>{ 
  return client.saveCopyFromExisting(data).then( response => {
    if(response.status === 200 || response.ok){
      response.json().then(responsejson => {   
        dispatch(setPropertyWalkThroughFormNextStep())
        dispatch(setPropertyWalkThroughFormData({copyFromSuiteIdApiCalling:false, FromWalkthroughsId: null, ToWalkthroughsId: null, checkList: []}))
      })
    }else{
      alert('some thing went wrong in saving cofig type')
    }
  })
}


export const fetchConfigureTypeWalkThroughData = (walkThroughId, type) => dispatch => {
  dispatch(startLoading())
  return client.fetchConfigureTypeWalkThroughData(walkThroughId).then( response => {
    if(response.status === 200 || response.ok){
      response.json().then( responsejson => {
        dispatch(stopLoading())
        dispatch(setPropertyWalkThroughFormData({configTypeSaved:responsejson.data[0]}))
      })
    }
  })
}

  export const getAreaAndSubAreaStatus = walkThroughId => dispatch => {
    return client.getAreaAndSubAreaStatus(walkThroughId).then( response => {
    if( response.status === 200 || response.ok ){
      response.json().then(
        responsejson => {
          dispatch(
            setPropertyWalkThroughFormData({areaAndSubAreaStatus:responsejson})
         )
        }
      )
    }
  })
}

  export const updateSubAreaCheckStatus = (subAreaId,status,walkthroughId) => dispatch => {
    return client.updateSubAreaCheckStatus(subAreaId,status,walkthroughId).then( response => {
    if(response.status === 200 || response.ok){
      response.json().then( responsejson => {
        dispatch(setEasyWalkThroughFormData({ processing: false, state: '' }))
      })
    }
  })
}

export const fetchPropertyWalkthrough = (suiteId, roleName) => dispatch => {
  return client.fetchSuiteWalkThroughs(suiteId, roleName).then( response => {
    if(response.status === 200 && response.ok){
      response.json().then( responsejson => {
        if(responsejson && responsejson.statusCode === 200) {
          dispatch(fetchWalkThroughsDone(responsejson.data));
        } else {
          dispatch(fetchWalkThroughsDone([]))
        }
      })
    } else {      
      dispatch(fetchWalkThroughsDone([]))
    }
  }).catch(() => {
    dispatch(fetchWalkThroughsDone([]))
  })
}

export const validateEndingWalkThroughEarly = ( walkthroughId ) => dispatch => {
  return client.validateEndingWalkThroughEarly(walkthroughId)
    .then(response => {
      if(response.ok || response.status){
        response.json().then(
          responsejson => { 
            dispatch( setPropertyWalkThroughFormData({validateEndingWalkThroughEarly:responsejson}))
          }
        )
      }
    }
      
    )
}

export const setWalkthroughReviewStatus = (data) => dispatch => {
  dispatch({
    type: TYPES.SET_WALKTHROUGH_REVIEW_STATUS,
    payload: data
  })
}

const onSaveNewWalkthrough = (data) => dispatch => {
  dispatch({
    type: TYPES.SAVE_WALKTHROUGH,
    payload: data
  })
}
export const addNewWalkthrough = (params, roleName) => dispatch => {
  dispatch(startFormLoading());
    return client.saveNewWalkthrough(params).then(response => {
      dispatch(stopFormLoading());
      if(response.status === 200) {
        response.json().then(responseJson => {
          if(responseJson.statusCode === 200) {
            dispatch(onSaveNewWalkthrough(responseJson.data));
            dispatch(fetchSuiteCounts(params.suiteId, roleName));
            toast.success('Walkthrough created successfully.',{autoClose:2000,position:'top-center'})
            dispatch(setValidation("Saved"));
          } else {
            toast.error('Walkthrough creation failed.',{autoClose:2000,position:'top-center'})
            dispatch(clearValidation());
          }
        })
      } else {
        toast.error('Walkthrough creation failed.',{autoClose:2000,position:'top-center'})
        dispatch(clearValidation());
      }
    }).catch(() => {
      dispatch(stopFormLoading());
      toast.error( '🚫 Something went wrong while creating walkthrough.',{autoClose:2000,position:'top-center'})
      dispatch(clearValidation());
    })
}